import axios from 'axios';
import { SET_LOGIN_USER_REQUEST,
         SET_LOGIN_USER_SUCCESS,
         SET_LOGIN_USER_ERROR} from './../../constants/auth/auth';

export const loginUser = (loadInitalSetup, payload, landingPage=`/close_loop`) => (dispatch) => {
    try {
        dispatch({type: SET_LOGIN_USER_REQUEST})
        const url = "/api/user/login";
        axios.post(url, payload).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;

                dispatch({type: SET_LOGIN_USER_SUCCESS, payload: data});
                let metaData = {
                   'atk': window.btoa(data['access_token']),
                   'rtk': window.btoa(data['refresh_token'])
                }
                localStorage.setItem('tk',window.btoa(JSON.stringify(metaData)));
                loadInitalSetup(landingPage);
            } else {
                const { data } = response;
                dispatch({type: SET_LOGIN_USER_ERROR, payload: data['message']});
            }
        }).catch((error) => {
            console.log(error);
            error.response.data.message ?
                (
                    dispatch({
                        type: SET_LOGIN_USER_ERROR,
                        payload: error.response.data.message
                    })
                ) : (
                    dispatch({
                        type: SET_LOGIN_USER_ERROR,
                        payload: "Error Occurred while processing this request"
                    })
                )
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_LOGIN_USER_ERROR, payload: error.message});
    }
}